export const acceptedTextFileExtensions = [".txt", ".doc", ".docx", ".pdf", ".odt", ".rtf", ".xlsx", ".xls"];

export const acceptedImageFileExtensions = [".jpeg", ".jpg", ".png", ".bmp", ".svg"];

export const acceptedAudioFileExtensions = [".mp3", ".wav", ".aac", ".flac", ".ogg"];

export const acceptedVideoFileExtensions = [".mp4", ".avi", ".mkv", ".mov", ".wmv"];
